<template>
    <div>
        <the-header>
            <template v-slot:title>
                {{ $route.meta.title }}
            </template>
            <template v-slot:deliveries>
                <p
                    v-if="totalDelivered && totalDeliveries"
                    class="is-size-5"
                >
                    Dostarczono: <strong>{{ totalDelivered }}/{{ totalDeliveries }}</strong>
                </p>
            </template>
        </the-header>
        <section class="section">
            <div
                class="container"
                v-if="loadingStatus == 'loading'"
            >
                <div class="columns">
                    <div class="column has-text-centered">
                        <br />
                        <h1 class="title">Trwa pobieranie zamówień</h1>
                        <svg-icon
                        class="svg svg-icon--background svg-icon__icon--loader"
                        type="return"
                        />
                    </div>
                </div>
            </div>
            <div
                class="container"
                v-else-if="deliveries && deliveries.length > 0"
            >
                <the-delivery
                    v-for="(delivery, index) in deliveries"
                    v-bind:key="index"
                    :id="index"
                    :delivery="delivery"
                />
            </div>
            <div class="container" v-else>
                <div class="columns">
                    <div class="column has-text-centered">
                        <br />
                        <h1 class="title">Brak dostarczonych zamowień</h1>
                        <svg-icon
                            class="svg svg-icon--background"
                            type="box"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader'
import TheDelivery from '@/components/TheDelivery'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'Deliveries',
    components: {
        'the-delivery': TheDelivery,
        'the-header': TheHeader,
        'svg-icon': SvgIcon
    },
    metaInfo: {
        title: 'Dostarczone'
    },
    computed: {
        loadingStatus(){
            return this.$store.getters.getLoadingStatus
        },
        deliveries(){
            return this.$store.getters.getDelivered
        },
        totalDeliveries(){
            return this.$store.getters.getTotalDeliveries
        },
        totalDelivered(){
            return this.$store.getters.getTotalDelivered
        },

    },
    created(){
        this.$store.dispatch('fetchDeliveries')
    }
}
</script>
<style lang="sass" scoped>
.section
    margin-bottom: 50vh
</style>
